export enum ActionName {
  Close = 'close',
  Added_Payment = 'addedPayment',
  Added_Group = 'addedGroup',
  Silent_Login = 'silentLogin',
}

export interface GoBackToMobileAppProps {
  action: ActionName;
  accessToken?: string | null;
  groupId?: string;
}

export interface NextStepProps {
  nextStep: () => void;
  totalSteps: number;
  currentStep: number;
}
